// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 58 ? "quill" : chunkId) + "." + {"18":"1d95ce4eb186caf9","58":"27138d77cc96b10a","726":"85957cafa16c6412","940":"932a6e1c1b785ce7"}[chunkId] + ".js";
};